import { render, staticRenderFns } from "./BrandRecord.vue?vue&type=template&id=625ab903&scoped=true"
import script from "./BrandRecord.vue?vue&type=script&lang=js"
export * from "./BrandRecord.vue?vue&type=script&lang=js"
import style0 from "./BrandRecord.vue?vue&type=style&index=0&id=625ab903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625ab903",
  null
  
)

export default component.exports